import { RootState } from "@base/store";
import { IconButton, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import {
  Avatar,
  ProfileWrapper,
  UserFullName,
  UserInfoContainer,
} from "./editToggle.styled";
import { EditProfileProps } from "./editToggle.type";

const EditToggle = ({ handlePhoto }: EditProfileProps) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const user = useSelector((state: RootState) => state.user.user);
  const inputFile = useRef<HTMLInputElement | null>(null);

  const stringAvatar = (name: string) => {
    return {
      children: `${name?.split(" ")[0][0]?.toUpperCase()}${name
        ?.split(" ")[1][0]
        ?.toUpperCase()}`,
    };
  };

  const onFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      setSelectedFile(files[0]);
    }
  };

  const onAvatarClick = () => {
    // `current` points to the mounted file input element, if available
    inputFile.current?.click();
  };

  const displayName = () => {
    let name = "";
    if (user?.firstName) {
      name = user?.firstName;
    }
    if (user?.lastName) {
      name = user?.lastName;
    }
    if (user?.firstName && user?.lastName) {
      name = `${user?.firstName} ${user?.lastName}`;
    }
    return name;
  };

  useEffect(() => {
    if (selectedFile) {
      handlePhoto(selectedFile);
    }
  }, [selectedFile]);

  return (
    <UserInfoContainer>
      <ProfileWrapper>
        <IconButton onClick={onAvatarClick}>
          <input
            type="file"
            id="file"
            ref={inputFile}
            style={{ display: "none" }}
            onChange={onFileChange}
          />
          {user?.profileImg ? (
            <Avatar alt="user Photo" src={user?.profileImg} />
          ) : (
            <Avatar
              alt="user Photo"
              {...stringAvatar(`${user?.firstName} ${user?.lastName}`)}
            />
          )}
        </IconButton>
        <UserFullName>{displayName()}</UserFullName>
      </ProfileWrapper>
    </UserInfoContainer>
  );
};

export { EditToggle };
